import Api from './api';

const DividaService = {
    cadastro: async (params) => {
        const response = await Api.post('/restrito/divida/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },

    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/divida/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletar: (id) => {
        Api.delete(`/restrito/divida/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    dividaEdit: async (id) => {
        const response = await Api.get(`/restrito/divida/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/restrito/divida/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/restrito/divida/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    }
}

export default DividaService;